import styled from "styled-components"

const StyledTitle = styled.div`
position absolute;
top: 50px;
left: 50px;
background-color: none;
font-size: 2em;
color: #EEE;
z-index: 5;
`

export default StyledTitle